import { FetchUtil } from "../util/FetchUtil";
import { HealioErrorModal } from "../components/healioGlobal/HealioErrorModal"
import { IPollAnswerServiceEndpoint } from "../models/HssPoll/IPollAnswerServiceEndpoint";
import { WyanokeUtil } from "../util/WyanokeUtil";
import { IPollAnswerModel } from "../models/HssPoll/IPollAnswerModel";
import { IPollAnswerCountModel } from "../models/HssPoll/IPollAnswerCountModel";
import { StringUtil } from "../util/StringUtil";
import { PollCompleteModel } from "../models/HssPoll/PollCompleteModel";

export class HssPollAnswerService {
  constructor(private readonly _endpoint: IPollAnswerServiceEndpoint) { }

  public async loadAnswers(
    pollId: string,
    anonymousId: string | null
  ): Promise<IPollAnswerModel[] | null> {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    const profile = await WyanokeUtil.loadUserProfile(true, false);

    const contactId = profile?.contactid || "";
    const values = {
      ContactId: contactId,
      AnonymousID: anonymousId,
      PollId: pollId
    };

    let pollAnswers: IPollAnswerModel[] | null = null;

    if(!contactId && !anonymousId){
      return pollAnswers;
    }
    const raw = await FetchUtil.sendMessage(
      endpoint,
      values
    );

    if (typeof raw !== "object") {
      const msg = "Unexpected response from server";
      console.error(msg, raw);
      HealioErrorModal.triggerHealioErrorModalEvent();
      return null;
    }

    pollAnswers = raw as IPollAnswerModel[];

    return pollAnswers;
  }

  public async saveAnswers(
    pollAnswerData: PollCompleteModel
  ): Promise<boolean> {
    const endpoint = this._endpoint.save;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    FetchUtil.sendMessage(
      endpoint,
      pollAnswerData
    ).then((response: any) => {

      const expected = "answers saved";
      if (!response || response?.result?.toLowerCase() !== expected) {
        console.error("Unexpected response from server.");
        return false;
      }
    });

    return true;
  }

  public async getAnswerCounts(
    pollId: string,
    questionId: string
  ): Promise<IPollAnswerCountModel[] | null> {
    const endpoint = this._endpoint.getAnswerCounts;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const queryString = [
      "pollId=" + pollId,
      "questionId=" + questionId
    ].filter(Boolean).join("&");

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { query }) || "")
        .replace(/\{(?:query)\}/g, "");

    const raw = await FetchUtil
      .sendMessage({ method: endpoint.method, url }, null) as IPollAnswerCountModel[];

    console.log(`PollAnswerCount Type: ${raw}`);

    if (typeof raw !== "object") {
      const msg = "Unexpected response from server";
      console.error(msg, raw);
      HealioErrorModal.triggerHealioErrorModalEvent();
      return null;
    }

    return raw;
  }

}
